module.exports = __webpack_public_path__ + "static/media/contact.ed9f1e45.png";